import { render, staticRenderFns } from "./FiringsConfigComponent.vue?vue&type=template&id=66858b77&scoped=true&"
import script from "./FiringsConfigComponent.vue?vue&type=script&lang=js&"
export * from "./FiringsConfigComponent.vue?vue&type=script&lang=js&"
import style0 from "./FiringsConfigComponent.vue?vue&type=style&index=0&id=66858b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66858b77",
  null
  
)

export default component.exports